import { noop, useSettings } from '@capsicum/common';
import { Text, useInfoModal } from '@capsicum/common-web';
import { useWCPledgeErrorModalTexts } from '@capsicum/features/world-championship-pledge/shared';
import styled from 'styled-components';

export const useWCPledgeErrorModal = (subtitleText?: string) => {
	const { primaryButtonText, secondaryButtonText, subtitle, title } = useWCPledgeErrorModalTexts();
	const { showInfoModal } = useInfoModal();
	const {
		settings: { contactUsHereLink }
	} = useSettings();

	const openContactLink = () => {
		window.open(contactUsHereLink, '_blank');
	};

	const openWCPledgeErrorModal = () => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: () => noop(),
				onSecondaryButtonHandler: openContactLink
			},
			buttonTexts: {
				primaryButtonText: primaryButtonText,
				secondaryButtonText: secondaryButtonText
			},
			image: 'warning',
			isClosable: true,
			subtitle: subtitleText || subtitle,
			testID: 'wcPledge-txError-modal',
			title: title,
			variant: 'confirm'
		});
	};

	return {
		openWCPledgeErrorModal
	};
};

namespace S {
	export const ContentText = styled(Text)`
		text-align: center;
	`;
}
